import request from './request'

export default {
    getCouponDetail: data => request.post('/api/userCoupon/getCounponById', data),
    reviceCoupon: data => request.post('/api/userCoupon/couponIssue', data)
}